import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  VatNumberRequest,
} from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitVatNumber = createAsyncThunk<
  VatNumberRequest,
  VatNumberRequest,
  ThunkApi
>("submitVatNumber", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addVatNumber(args);

    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error = {
      title: "Salvataggio partita IVA",
      description:
        "Non siamo riusciti a salvare la tua partita IVA.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
